import { RegistryHistoryType } from '@/api/backend/types';
import { RegistryStatusBadge } from '@/components/registry-status-badge';
import { ResponsiveDataView } from '@/components/responsive-data-view';
import { formatIsoDate } from '@/lib/utils';
import {
  DataTableColumnType,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@opaz/ui-components';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const PermitHistoryTab = ({ permitId, history }: { permitId: string; history: RegistryHistoryType[] }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const columns: DataTableColumnType<RegistryHistoryType>[] = [
    {
      title: t('registry.permit.sectionTabs.historyTab.table.headings.applicationNumber'),
      render: (item) => item.applicationNumber,
    },
    {
      title: t('registry.permit.sectionTabs.historyTab.table.headings.type'),
      render: (item) => t(`backend.codes.${item.applicationTypeCode}` as unknown as TemplateStringsArray),
    },
    {
      title: t('registry.permit.sectionTabs.historyTab.table.headings.date'),
      render: (item) => formatIsoDate(item.date, i18n.language),
    },
    {
      title: t('registry.permit.sectionTabs.historyTab.table.headings.status'),
      render: (item) => <RegistryStatusBadge statusCode={item.statusCode} />,
    },
    {
      title: t('registry.permit.sectionHistory.viewDetails'),
      render: (item) => (
        <Link
          onClick={() => {
            navigate({
              to: '/registry/permits/$permitId',
              params: { permitId },
              search: { version: item.applicationNumber },
            });

            window.scrollTo(0, 0);
          }}
        >
          {t('registry.permit.sectionHistory.viewDetails')}
        </Link>
      ),
    },
  ];
  return (
    <>
      <ResponsiveDataView
        columns={columns}
        data={history}
        emptyMessage={t('registry.permit.sectionHistory.table.noHistoryAvailable')}
        getRowKey={(item) => item.applicationNumber}
      >
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{t('registry.permit.sectionTabs.historyTab.table.headings.applicationNumber')}</TableHead>
              <TableHead>{t('registry.permit.sectionTabs.historyTab.table.headings.type')}</TableHead>
              <TableHead>{t('registry.permit.sectionTabs.historyTab.table.headings.date')}</TableHead>
              <TableHead className="text-end">
                {t('registry.permit.sectionTabs.historyTab.table.headings.status')}
              </TableHead>
              <TableHead />
            </TableRow>
          </TableHeader>
          <TableBody>
            {history.length > 0 ? (
              history.map((history) => (
                <TableRow key={history.applicationNumber}>
                  <TableCell className="text-base">{history.applicationNumber}</TableCell>
                  <TableCell className="text-base">
                    {t(`backend.codes.${history.applicationTypeCode}` as unknown as TemplateStringsArray)}
                  </TableCell>
                  <TableCell className="text-base">{formatIsoDate(history.date, i18n.language)}</TableCell>
                  <TableCell className="text-base text-end">
                    <RegistryStatusBadge statusCode={history.statusCode} />
                  </TableCell>
                  <TableCell className="text-base text-end">
                    <Link
                      onClick={() => {
                        navigate({
                          to: '/registry/permits/$permitId',
                          params: { permitId },
                          search: { version: history.applicationNumber },
                        });

                        window.scrollTo(0, 0);
                      }}
                    >
                      {t('registry.permit.sectionHistory.viewDetails')}
                    </Link>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} className="text-center">
                  {t('registry.permit.sectionHistory.table.noHistoryAvailable')}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </ResponsiveDataView>
    </>
  );
};
